<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Khóa học</h2>
        <div>
          <el-button v-if="accountInfo.user_type == 1" @click="createModelCopy" size="small" type="info" class="btn-create">Copy khóa học</el-button>
          <el-button v-if="accountInfo.user_type == 1" @click="createModelExcel" size="small" type="info" class="btn-create">Tải file Excel</el-button>
          <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button>
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Trạng thái" class="input-select" @change="changedCoursesStatus">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.type" filterable clearable placeholder="Loại khóa học" class="input-select" @change="changedCoursesType">
            <el-option
              v-for="item in lists.listTypeCourse"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.category_course_id" filterable clearable placeholder="Danh mục khóa học" class="input-select" @change="changedCoursesCategory">
            <el-option
              v-for="item in lists.listCategoryCourse"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.teacher_id" filterable clearable placeholder="Giảng viên" class="input-select" @change="changedCoursesTeacher">
            <el-option
              v-for="item in lists.listTeacher"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.hot" filterable clearable placeholder="Nổi bật" class="input-select" @change="changedCoursesHot">
            <el-option
              v-for="item in lists.listHot"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.level_id" filterable clearable placeholder="Chọn phân hệ" class="input-select" @change="changedCoursesLevel">
            <el-option
              v-for="item in lists.listLevel"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.facult_id" filterable clearable placeholder="Chọn chuyên ngành" class="input-select" @change="changedCoursesFacult">
            <el-option
              v-for="item in lists.listFacult"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="3"></el-col>
        <el-col :span="5"></el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div>
            Hiển thị tới khóa học <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> khóa học / Tổng: {{ this.total_lessons }} video
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            prop="image"
            width="180"
            align="center"
            label="Ảnh khóa học">
            <template slot-scope="scope">
              <img v-if="scope.row.image_path" :src="scope.row.image_path" class="course-image">
            </template>
          </el-table-column>
          <el-table-column
            label="Thông tin">
            <template slot-scope="scope">
              <div class="courses-info" v-if="scope.row.type === 0">
                <span>
                  Tên khóa học: <span style="font-weight: bold">{{ scope.row.name }}</span>
                </span>
                <span>
                  Giá khóa học : <span style="color: red">{{ scope.row.price | vnd }}</span>
                </span>
                <span>
                  Lĩnh vực : <span style="font-weight: bold">{{ scope.row.category_course_text }}</span>
                </span>
                <span>
                  Số lượng video : <span style="font-weight: bold">{{ scope.row.total_lessons }}</span>
                </span>
              </div>
              <div class="courses-info" v-if="scope.row.type === 1">
                <span>
                  Tên khóa học:
                  <span v-if="scope.row.logic == 0" style="font-weight: bold">{{ scope.row.name }}</span>
                  <span v-else style="font-weight: bold; color: green">{{ scope.row.name }}</span>
                </span>
                <span>
                  Mã khóa học: <span style="font-weight: bold; color: red">{{ scope.row.code }}</span>
                </span>
                <span>
                  Số lượng video : <span style="font-weight: bold">{{ scope.row.total_lessons }}</span>
                </span>
                <span class="d-flex flex-column" v-if="scope.row.level_id">
                    <span>
                      <strong>Phân hệ: </strong>
                      {{ scope.row.level_text }}
                    </span>
                    <span>
                      <strong>Chuyên ngành: </strong>
                      {{ scope.row.facult_text }}
                    </span>
                </span>
                <span>
                  Loại khóa học:
                  <span v-if="scope.row.type == 0" style="color: #409eff">{{ scope.row.type_text }}</span>
                  <span v-if="scope.row.type == 1" style="color: red">{{ scope.row.type_text }}</span>
                </span>
                <span>
                  Thời gian Tạo : <span style="font-weight: bold">{{ scope.row.created_at }}</span>
                </span>
                <span>
                  Thời gian Update : <span style="font-weight: bold">{{ scope.row.updated_at }}</span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="accountInfo.user_type === 1"
            prop="id"
            width="100"
            align="center"
            label="Mã copy">
            <template slot-scope="scope">
              <strong>{{ scope.row.id }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            label="Phân hệ / Chuyên ngành">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                :title="scope.row.name"
                width="200"
                trigger="hover">
                <div>
                  <div
                    :key="item.level_id"
                    v-for="item in scope.row.course_level_facults.data"
                    class="course_level_facult">
                    <span>{{ item.level_name }}</span>
                    <span>/ {{ item.facult_name }}</span>
                  </div>
                </div>
                <el-tag slot="reference">Xem</el-tag>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="Nổi bật"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.hot"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeHot(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="Hành động"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <!-- <el-tooltip v-if="scope.row.id > 603" effect="dark" content="Chương/bài học" placement="top">
                  <span @click="updateConfigModel(scope.row)">
                    <i class="fas fa-bars"></i>
                  </span>
                </el-tooltip> -->
                <!-- <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip> -->
<!--                 <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip> -->
                <el-tooltip effect="dark" content="Sửa 2" placement="top">
                  <span @click="updateModel2(scope.row)">
                    <i class="fas fa-edit"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'
export default {
  name: 'Courses',
  metaInfo () {
    return {
      title: 'Khóa học'
    }
  },
  components: {
    draggable
  },
  data () {
    return {
      loading: false,
      searching: false,
      total_lessons: 0,
      filter: {
        q: '',
        type: '',
        status: '',
        hot: '',
        category_course_id: '',
        teacher_id: '',
        level_id: '',
        facult_id: '',
        daterange: '',
        page: 1,
        limit: 15,
        sorted: '',
        include: 'course_level_facults'
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Tên khóa học',
          groupFiled: [
            { label: 'name:-1', text: 'Tăng dần' },
            { label: 'name:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listHot: [
          {key: 1, value: 'Nổi bật'},
          {key: 0, value: 'Bình thường'}
        ],
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listTeacher: [
          {key: 0, value: 'Chọn giảng viên'}
        ],
        listTypeCourse: [
          {key: 0, value: 'Khóa học kĩ năng'},
          {key: 1, value: 'Khóa học đào tạo'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: [],
        listKey: []
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
    this.fetchListCategoryCourse()
    if (this.accountInfo.user_type === 1) {
      this.fetchListTeacher()
    }
    this.fetchLevel()
  },
  computed: {
    ...mapGetters('account', ['accountInfo']),
    ...mapGetters('courses', [
      'getSearchCoursesStatus',
      'getSearchCoursesType',
      'getSearchCoursesCategory',
      'getSearchCoursesTeacher',
      'getSearchCoursesHot',
      'getSearchCoursesLevel',
      'getSearchCoursesFacult'
    ])
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    ...mapActions('courses', ['changeSearchCoursesStatus',
      'changeSearchCoursesType',
      'changeSearchCoursesCategory',
      'changeSearchCoursesTeacher',
      'changeSearchCoursesHot',
      'changeSearchCoursesLevel',
      'changeSearchCoursesFacult']),
    changedCoursesStatus (payload) {
      this.changeSearchCoursesStatus(payload)
    },
    changedCoursesType (payload) {
      this.changeSearchCoursesType(payload)
    },
    changedCoursesCategory (payload) {
      this.changeSearchCoursesCategory(payload)
    },
    changedCoursesTeacher (payload) {
      this.changeSearchCoursesTeacher(payload)
    },
    changedCoursesHot (payload) {
      this.changeSearchCoursesHot(payload)
    },
    changedCoursesLevel (payload) {
      this.changeSearchCoursesLevel(payload)
    },
    changedCoursesFacult (payload) {
      this.changeSearchCoursesFacult(payload)
    },
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'courses-create'})
    },
    createModelExcel () {
      this.$router.push({name: 'courses-create-excel'})
    },
    createModelCopy () {
      this.$router.push({name: 'courses-copy'})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true

      this.filter.status = this.getSearchCoursesStatus
      this.filter.type = this.getSearchCoursesType
      this.filter.category_course_id = this.getSearchCoursesCategory
      this.filter.teacher_id = this.getSearchCoursesTeacher
      this.filter.level_id = this.getSearchCoursesLevel
      this.filter.hot = this.getSearchCoursesHot
      this.filter.facult_id = this.getSearchCoursesFacult

      axios.get('courses', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về lĩnh vực khóa học
    fetchListCategoryCourse () {
      axios.get('category-courses', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về giảng viên
    fetchListTeacher () {
      axios.get('users', {params: {'status': 1, 'user_type': 2, 'school_id_list': this.accountInfo.school_id}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSchool () {
      axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchLevel () {
      let data = {
        'status': 1,
        'limit': -1,
        'sort': 'id:1'
      }
      axios.get('levels', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      let data = {
        'status': 1,
        'limit': -1,
        'level_id': this.filter.level_id,
        'sort': 'id:1'
      }
      axios.get('facults', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.modelData.school_id,
        'level_id': this.modelData.level_id,
        'facult_id': this.modelData.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
      // axios.get('lessons').then(response => {
      //   switch (response.code) {
      //     case 200:
      //       this.total_lessons = response.meta.pagination.total
      //       break
      //     default:
      //       break
      //   }
      // })
    },
    // Xem chi tiết
    showModel (model) {
      this.$router.push({name: 'courses-show', params: {course_id: model.id}})
    },
    updateModel (model) {
      this.$router.push({name: 'courses-update', params: {course_id: model.id}})
    },
    updateModel2 (model) {
      this.$router.push({name: 'courses-update-v2', params: {course_id: model.id}})
    },
    updateConfigModel (model) {
      this.$router.push({name: 'courses-update-config', params: {id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('courses/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeHot (model) {
      let dataUpdate = {
        'hot': model.hot
      }
      axios.post('courses/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa khóa học: ' + model.name + ' - Mã môn: ' + model.code, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('courses/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.hot': function () {
      this.fetchDatabaseModel()
    },
    'filter.category_course_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.teacher_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.type': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    },
    'filter.level_id': function () {
      this.filter.facult_id = ''
      this.lists.listFacult = []
      if (this.filter.level_id) {
        this.fetchFacult()
      }

      this.fetchDatabaseModel()
    },
    'filter.facult_id': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 150px;
  border-radius: 2px;
}
.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}
.course_level_facult {
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 8px;
  padding-bottom: 5px;
}
.course_level_facult:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/courses/Index.vue